import { up as upV1 } from '../js/migrations/v1_0.js';
import { up as upV2 } from '../js/migrations/v2_0.js';
import { up as upV3 } from '../js/migrations/v3_0.js';
import { up as upV4 } from '../js/migrations/v4_0.js';
import { up as upV5 } from '../js/migrations/v5_0.js';

const migrations = [
    {
        version: 1,
        up: upV1
    },
    {
        version: 2,
        up: upV2
    },
    {
        version: 3,
        up: upV3
    },
    {
        version: 4,
        up: upV4
    },
    {
        version: 5,
        up: upV5
    }
]

export const migarateToLatest = (pageContent) => {
    if (isLatestVersion(pageContent)) {
        return pageContent;
    }

    const hasVersion = Object.keys(pageContent).includes('version');

    if (!hasVersion) {
        pageContent.version = 0;
    }

    for (let index = 0; index < migrations.length; index++) {
        const migration = migrations[index];

        if (migration.version <= pageContent.version) {
            continue;
        }
        
        pageContent = migration.up(pageContent);

        pageContent.version = migration.version;
    }

    return pageContent;
}

export const isLatestVersion = (pageContent) => {
    const hasVersion = Object.keys(pageContent).includes('version');
    return hasVersion && pageContent.version === migrations[migrations.length - 1].version;
}